module.exports = __webpack_public_path__ + "img/camwater.287bb76d.png";